import { axiosInstance } from "./config";

export const submitPackageRequest = async (data) => {
  const res = await axiosInstance.post("/package-request", data);
  return res.data;
};
